import React from 'react';

function Brand({ light = false }) {
  return (
    <div className={`brand ${light ? 'brand--light' : ''}`}>
      <span className="brand__mark">
        <img src="/aafavicon.png" alt="Angus Ashton Film" />
      </span>
      <span>Angus Ashton Film</span>
    </div>
  );
}

export default Brand;
